import queryString from 'utils/queryString';

import nextApiGetRequest from '../lib/nextApiGetRequest';

const request = async (params = {}) => {
  const query = queryString.stringify(params, {
    arrayFormatSeparator: ',',
  });

  const response = await nextApiGetRequest(`/api/content?${query}`);
  const json = await response.json();

  return json.data;
};

const content = {
  product: async productId => request({ type: 'product', id: productId }),
  products: async productIds => request({ type: 'products', ids: productIds }),
  category: async categoryId => request({ type: 'category', id: categoryId }),
  categories: async categoryIds => request({ type: 'categories', ids: categoryIds }),
  banner: async () => request({ type: 'banner' }),
  carousel: async () => request({ type: 'carousel' }),
  blog: async () => request({ type: 'blog' }),
  singleType: async type => request({ type: 'singleType', id: type }),
};

export default content;
